/* Totaria purchase gallery: hover zoom (desktop) and full-screen viewer (click / tap).
   Settings live on the "Totaria purchase" section → Image zoom. Delegated, so it survives
   section re-renders in the theme editor. */
(() => {
  if (window.__ttZoom) return;
  window.__ttZoom = true;

  const css = `
.tt-gallery[data-lightbox="true"] .tt-gallery__slide.is-active { cursor: zoom-in; }
.tt-gallery__slide img { transition: transform .12s ease-out; will-change: transform; }
.tt-gallery__slide.is-zooming { cursor: crosshair; }
.tt-gallery__slide.is-zooming img { transition: none; }
.tt-gallery__zoom {
  position: absolute; top: 12px; right: 12px; z-index: 2; width: 40px; height: 40px; border-radius: 50%;
  border: 0; background: rgba(255,255,255,.92); color: var(--tt-text, #12353F); cursor: pointer;
  box-shadow: 0 2px 8px rgba(0,0,0,.1); display: flex; align-items: center; justify-content: center;
}
.tt-gallery__zoom:focus-visible, .tt-lb button:focus-visible { outline: 2px solid #1A6B7F; outline-offset: 2px; }
.tt-lb {
  position: fixed; inset: 0; width: 100%; height: 100%; max-width: none; max-height: none; margin: 0; padding: 0;
  border: 0; background: rgba(8, 28, 34, .94); color: #fff; overflow: hidden;
}
.tt-lb::backdrop { background: rgba(8, 28, 34, .94); }
.tt-lb__view { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; overflow: hidden; touch-action: pinch-zoom; }
.tt-lb__img {
  max-width: min(100vw - 32px, 1400px); max-height: calc(100dvh - 120px); width: auto; height: auto;
  object-fit: contain; cursor: zoom-in; transition: transform .2s ease; user-select: none; -webkit-user-drag: none;
  background: #fff; border-radius: 12px;
}
.tt-lb.is-zoomed .tt-lb__img { cursor: zoom-out; transition: none; }
.tt-lb__btn {
  position: absolute; z-index: 2; width: 48px; height: 48px; border-radius: 50%; border: 0;
  background: rgba(255,255,255,.95); color: #12353F; cursor: pointer; display: flex; align-items: center; justify-content: center;
  box-shadow: 0 2px 10px rgba(0,0,0,.25);
}
.tt-lb__close { top: 16px; right: 16px; }
.tt-lb__prev { left: 16px; top: 50%; transform: translateY(-50%); }
.tt-lb__next { right: 16px; top: 50%; transform: translateY(-50%); }
.tt-lb__count { position: absolute; left: 50%; bottom: 20px; transform: translateX(-50%); font: 600 13px/1 system-ui, sans-serif; padding: 8px 12px; border-radius: 999px; background: rgba(255,255,255,.14); }
.tt-lb[data-single] .tt-lb__prev, .tt-lb[data-single] .tt-lb__next, .tt-lb[data-single] .tt-lb__count { display: none; }
@media (max-width: 699px) {
  .tt-lb__prev, .tt-lb__next { top: auto; bottom: 10px; transform: none; width: 44px; height: 44px; }
  .tt-lb__img { max-width: calc(100vw - 16px); max-height: calc(100dvh - 140px); border-radius: 8px; }
}
@media (prefers-reduced-motion: reduce) { .tt-gallery__slide img, .tt-lb__img { transition: none; } }`;
  const style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  const fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  const icon = {
    close: '<svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true" focusable="false"><path d="M4 4l10 10M14 4L4 14" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
    prev: '<svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M13 8H3.5M7.5 4l-4 4 4 4" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    next: '<svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M3 8h9.5M8.5 4l4 4-4 4" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  };

  /* ---------- Hover zoom ---------- */
  const zoomOn = (slide, gallery, e) => {
    const img = slide.querySelector('img');
    if (!img) return;
    const level = Math.max(1.2, (parseFloat(gallery.dataset.zoomLevel) || 220) / 100);
    if (!slide.classList.contains('is-zooming')) {
      slide.classList.add('is-zooming');
      // Ask the browser for a sharper candidate from the srcset while zoomed.
      if (!img.dataset.ttSizes) { img.dataset.ttSizes = img.getAttribute('sizes') || ''; img.setAttribute('sizes', `${Math.round(560 * level)}px`); }
    }
    const r = img.getBoundingClientRect();
    const x = Math.min(100, Math.max(0, ((e.clientX - r.left) / r.width) * 100));
    const y = Math.min(100, Math.max(0, ((e.clientY - r.top) / r.height) * 100));
    img.style.transformOrigin = `${x}% ${y}%`;
    img.style.transform = `scale(${level})`;
  };
  const zoomOff = (slide) => {
    const img = slide?.querySelector('img');
    slide?.classList.remove('is-zooming');
    if (img) { img.style.transform = ''; }
  };

  document.addEventListener('pointermove', (e) => {
    if (e.pointerType !== 'mouse' || !fine.matches) return;
    const slide = e.target.closest?.('.tt-gallery__slide.is-active');
    const gallery = slide?.closest('[data-gallery]');
    if (!slide || gallery?.dataset.zoomHover !== 'true') return;
    if (e.target.closest('button')) { zoomOff(slide); return; }
    zoomOn(slide, gallery, e);
  });
  document.addEventListener('pointerout', (e) => {
    const slide = e.target.closest?.('.tt-gallery__slide.is-zooming');
    if (slide && !slide.contains(e.relatedTarget)) zoomOff(slide);
  });
  // Reset when the carousel changes slide.
  document.addEventListener('click', (e) => {
    if (e.target.closest?.('[data-gallery] [data-prev], [data-gallery] [data-next], [data-gallery] [data-thumb]')) {
      e.target.closest('[data-gallery]').querySelectorAll('.tt-gallery__slide.is-zooming').forEach(zoomOff);
    }
  }, true);

  /* ---------- Full-screen viewer ---------- */
  let lb, lbImg, lbCount, items = [], idx = 0, opener = null, sx = null, sy = null;

  const build = (g) => {
    lb = document.createElement('dialog');
    lb.className = 'tt-lb';
    lb.setAttribute('aria-label', g.dataset.labelDialog || 'Product images');
    lb.innerHTML = `
      <div class="tt-lb__view"><img class="tt-lb__img" alt="" decoding="async"></div>
      <button type="button" class="tt-lb__btn tt-lb__close" data-lb-close>${icon.close}</button>
      <button type="button" class="tt-lb__btn tt-lb__prev" data-lb-prev>${icon.prev}</button>
      <button type="button" class="tt-lb__btn tt-lb__next" data-lb-next>${icon.next}</button>
      <p class="tt-lb__count" aria-live="polite"></p>`;
    document.body.appendChild(lb);
    lbImg = lb.querySelector('.tt-lb__img');
    lbCount = lb.querySelector('.tt-lb__count');

    lb.querySelector('[data-lb-close]').addEventListener('click', close);
    lb.querySelector('[data-lb-prev]').addEventListener('click', () => show(idx - 1));
    lb.querySelector('[data-lb-next]').addEventListener('click', () => show(idx + 1));
    lb.addEventListener('close', onClosed);
    lb.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(idx - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); show(idx + 1); }
    });
    // Click on the dark area closes; click on the image toggles zoom (desktop).
    lb.querySelector('.tt-lb__view').addEventListener('click', (e) => {
      if (e.target !== lbImg) { close(); return; }
      if (!fine.matches) return;
      if (lb.classList.toggle('is-zoomed')) panTo(e); else lbImg.style.transform = '';
    });
    lbImg.addEventListener('mousemove', (e) => { if (lb.classList.contains('is-zoomed')) panTo(e); });
    lbImg.addEventListener('touchstart', (e) => {
      if (e.touches.length !== 1) { sx = null; return; }
      sx = e.touches[0].clientX; sy = e.touches[0].clientY;
    }, { passive: true });
    lbImg.addEventListener('touchend', (e) => {
      if (sx === null || (window.visualViewport && window.visualViewport.scale > 1.05)) { sx = null; return; }
      const dx = e.changedTouches[0].clientX - sx;
      const dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) show(idx + (dx < 0 ? 1 : -1));
      sx = null;
    }, { passive: true });
  };

  const panTo = (e) => {
    const r = lbImg.getBoundingClientRect();
    const x = ((e.clientX - r.left) / r.width) * 100;
    const y = ((e.clientY - r.top) / r.height) * 100;
    lbImg.style.transformOrigin = `${x}% ${y}%`;
    lbImg.style.transform = 'scale(2)';
  };

  const show = (i) => {
    const n = items.length;
    if (!n) return;
    idx = ((i % n) + n) % n;
    lb.classList.remove('is-zoomed');
    lbImg.style.transform = '';
    lbImg.src = items[idx].src;
    lbImg.alt = items[idx].alt;
    lbCount.textContent = `${idx + 1} / ${n}`;
    // Warm the neighbours so arrows feel instant.
    [idx + 1, idx - 1].forEach((k) => { const it = items[((k % n) + n) % n]; if (it) { const p = new Image(); p.src = it.src; } });
  };

  const open = (gallery, startSlide) => {
    const slides = [...gallery.querySelectorAll('[data-slide]')].filter((s) => s.dataset.full);
    if (!slides.length) return;
    items = slides.map((s) => ({ src: s.dataset.full, alt: s.dataset.alt || '' }));
    if (!lb) build(gallery);
    lb.querySelector('[data-lb-close]').setAttribute('aria-label', gallery.dataset.labelClose || 'Close');
    lb.querySelector('[data-lb-prev]').setAttribute('aria-label', gallery.dataset.labelPrev || 'Previous image');
    lb.querySelector('[data-lb-next]').setAttribute('aria-label', gallery.dataset.labelNext || 'Next image');
    lb.toggleAttribute('data-single', items.length < 2);
    opener = document.activeElement;
    const start = Math.max(0, slides.indexOf(startSlide));
    gallery.querySelectorAll('.tt-gallery__slide.is-zooming').forEach(zoomOff);
    show(start);
    document.documentElement.style.overflow = 'hidden';
    lb.showModal();
    lb.querySelector('[data-lb-close]').focus({ preventScroll: true });
  };

  const close = () => { if (lb?.open) lb.close(); };
  const onClosed = () => {
    document.documentElement.style.overflow = '';
    lb.classList.remove('is-zoomed');
    if (opener && document.contains(opener)) opener.focus({ preventScroll: true });
  };

  document.addEventListener('click', (e) => {
    const gallery = e.target.closest?.('[data-gallery]');
    if (!gallery || gallery.dataset.lightbox !== 'true') return;
    const zoomBtn = e.target.closest('[data-zoom-open]');
    if (zoomBtn) {
      e.preventDefault();
      open(gallery, gallery.querySelector('.tt-gallery__slide.is-active'));
      return;
    }
    if (e.target.closest('button, a')) return;
    const slide = e.target.closest('.tt-gallery__slide.is-active');
    if (slide) open(gallery, slide);
  });
})();
